import React, { FC, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  FormHelperText,
} from '@mui/material';

interface PasswordChangeDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (oldPassword: string, newPassword: string) => Promise<void>;
}

const PasswordChangeDialog: FC<PasswordChangeDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNew, setConfirmNew] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    if (!oldPassword || !newPassword || !confirmNew) {
      setError('Preencha todos os campos');
      return;
    }
    if (newPassword !== confirmNew) {
      setError('As senhas não coincidem');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await onSubmit(oldPassword, newPassword);
      onClose();
    } catch (err) {
      console.error('Erro ao alterar a senha:', err);
      setError('Não foi possível alterar a senha. Verifique se a senha atual está correta.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Alterar Senha</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Senha atual"
          type="password"
          fullWidth
          value={oldPassword}
          onChange={(e) => {
            setOldPassword(e.target.value);
            setError(null);
          }}
          disabled={loading}
        />
        <TextField
          margin="dense"
          label="Nova senha"
          type="password"
          fullWidth
          value={newPassword}
          onChange={(e) => {
            setNewPassword(e.target.value);
            setError(null);
          }}
          disabled={loading}
        />
        <TextField
          margin="dense"
          label="Confirmar nova senha"
          type="password"
          fullWidth
          value={confirmNew}
          onChange={(e) => {
            setConfirmNew(e.target.value);
            setError(null);
          }}
          disabled={loading}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={handleConfirm} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Salvar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordChangeDialog;